import { render, staticRenderFns } from "./VerticalNavMenuGroup.vue?vue&type=template&id=3bbdaf79&scoped=true"
import script from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuGroup.vue?vue&type=style&index=0&id=3bbdaf79&prod&lang=scss"
import style1 from "./VerticalNavMenuGroup.vue?vue&type=style&index=1&id=3bbdaf79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbdaf79",
  null
  
)

export default component.exports